import { apiFetch } from "~lib/apiFetch";

const apiBasketPath = "/shop/basket";

export const fetchShopBasket = async () => {
  const response = await apiFetch(`${apiBasketPath}/products`);
  return response.json();
};

export const addOrUpdateProduct = async (productId, quantity) => {
  const response = await apiFetch(`${apiBasketPath}/products/${productId}`, {
    method: "POST",
    body: JSON.stringify({ quantity }),
  });
  return response.json();
};

export const removeProduct = async (productId) => {
  const response = await apiFetch(`${apiBasketPath}/products/${productId}`, {
    method: "DELETE",
  });
  return response.json();
};

export const updateBasketCustomer = async ({
  firstName,
  lastName,
  email,
  locale,
  shippingMethod,
}) =>
  apiFetch(`${apiBasketPath}/customer`, {
    method: "PUT",
    body: JSON.stringify({
      firstName,
      lastName,
      email,
      shippingMethod,
      locale,
    }),
  });

export const removeShopDiscount = async () => {
  const response = await apiFetch(`${apiBasketPath}/discount`, {
    method: "DELETE",
  });
  return response.json();
};

export const checkoutBasket = async ({ returnUrl }) => {
  const urlSearchParams = new URLSearchParams({
    returnUrl,
  });
  const response = await apiFetch(
    `${apiBasketPath}/checkout?${urlSearchParams.toString()}`,
    {
      method: "POST",
    },
  );
  return response.json();
};
